import { TraceKey } from 'src/Libs/system-charts/shared'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { PowermeterHardwareDataModel } from 'src/State/Storage/StorageModel'

export const TRACES_TO_IGNORE_DEFAULT_CHART: TraceKey[] = ['DC_PowerL1', 'DC_PowerL2', 'DC_PowerL3', 'Wallbox_energySolar', 'Wallbox_energyNetOut']

/*
 * Returns filtered available trace keys for the default chart
 */
export const getFilteredAvailableTraceKeysForDefaultChart = (
  availableLines: TraceKey[],
  wallboxes?: WallboxHardwareModel[],
  powermeters?: PowermeterHardwareDataModel
): TraceKey[] => {
  const hasMultipleWallboxes = wallboxes && wallboxes?.length > 1
  const hasMultipleProducers = powermeters && powermeters?.producers.length > 1
  const hasMultipleConsumers = powermeters && powermeters?.consumers.length > 1
  const hasMultipleBypassNoCharge = powermeters && powermeters?.bypassNoCharge.length > 1
  const hasMultipleBypassRegulation = powermeters && powermeters?.bypassRegulation.length > 1
  const hasMultipleEnera = powermeters && powermeters?.enera.length > 1

  return availableLines.filter(trace => {
    if (TRACES_TO_IGNORE_DEFAULT_CHART.includes(trace)) return false
    if (hasMultipleWallboxes && trace.startsWith('wb')) return false
    if (hasMultipleProducers && trace.startsWith('pm')) return false
    if (!hasMultipleWallboxes && trace.startsWith('Wallbox')) return false
    if (!hasMultipleWallboxes && trace.endsWith('energySolar')) return false
    if (!hasMultipleWallboxes && trace.endsWith('energyNetOut')) return false
    if (!hasMultipleProducers && trace.startsWith('Powermeter_production')) return false
    if (!hasMultipleConsumers && trace.startsWith('Powermeter_consumption')) return false
    if (!hasMultipleBypassNoCharge && trace.startsWith('Powermeter_NetIn_bypass_noCharge')) return false
    if (!hasMultipleBypassRegulation && trace.startsWith('Powermeter_NetIn_bypass')) return false
    if (!hasMultipleEnera && trace.startsWith('Powermeter_NetIn_enera')) return false
    return true
  })
}

/*
 * Returns filtered available trace keys for custom charts
 */
export const getFilteredAvailableTraceKeysForCustomChart = (
  availableLines: TraceKey[],
  wallboxes?: WallboxHardwareModel[],
  powermeters?: PowermeterHardwareDataModel
): TraceKey[] => {
  const hasSingleWallbox = wallboxes && wallboxes?.length <= 1
  const hasSingleProducer = powermeters && powermeters?.producers.length <= 1
  const hasSingleConsumer = powermeters && powermeters?.consumers.length <= 1
  const hasSingleBypassNoCharge = powermeters && powermeters?.bypassNoCharge.length <= 1
  const hasSingleBypassRegulation = powermeters && powermeters?.bypassRegulation.length <= 1
  const hasSingleEnera = powermeters && powermeters?.enera.length <= 1

  return availableLines.filter(trace => {
    if (hasSingleWallbox && trace.startsWith('Wallbox')) return false
    if (hasSingleProducer && trace.startsWith('Powermeter_production')) return false
    if (hasSingleConsumer && trace.startsWith('Powermeter_consumption')) return false
    if (hasSingleBypassNoCharge && trace.startsWith('Powermeter_NetIn_bypass_noCharge')) return false
    if (hasSingleBypassRegulation && trace.startsWith('Powermeter_NetIn_bypass')) return false
    if (hasSingleEnera && trace.startsWith('Powermeter_NetIn_enera')) return false
    return true
  })
}
